import { Project } from '../types';

export const extendedMockProjects: Project[] = [
  {
    id: 'p1',
    name: 'EcoTech Solutions',
    description: 'Plataforma de gestión de residuos inteligente usando IoT',
    elevatorPitch: 'Reducimos el impacto ambiental mediante tecnología IoT que optimiza la recolección de residuos en un 40%',
    stage: 'Validación',
    industry: 'Tecnología Ambiental',
    ownerId: 'user_emprendedor_1',
    documents: [
      {
        id: 'doc_1',
        name: 'Pitch Deck EcoTech',
        type: 'Pitch Deck',
        url: '/documents/ecotech-pitch.pdf',
        uploadedAt: '2024-02-01T10:00:00Z'
      },
      {
        id: 'doc_2',
        name: 'Modelo de Negocio Canvas',
        type: 'Modelo de Negocio',
        url: '/documents/ecotech-canvas.pdf',
        uploadedAt: '2024-02-15T10:00:00Z'
      }
    ],
    milestones: [
      {
        id: 'milestone_1',
        title: 'Validar MVP con 10 clientes',
        description: 'Conseguir 10 clientes piloto para validar la solución',
        completed: true,
        dueDate: '2024-03-31'
      },
      {
        id: 'milestone_2',
        title: 'Conseguir primera ronda de inversión',
        description: 'Levantar $100K en inversión semilla',
        completed: false,
        dueDate: '2024-06-30'
      },
      {
        id: 'milestone_3',
        title: 'Escalar a 50 clientes',
        description: 'Expandir la base de clientes a 50 empresas',
        completed: false,
        dueDate: '2024-12-31'
      }
    ],
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-04-01T10:00:00Z'
  },
  {
    id: 'p2',
    name: 'HealthConnect',
    description: 'App de telemedicina para zonas rurales',
    elevatorPitch: 'Conectamos pacientes rurales con médicos especialistas mediante telemedicina accesible',
    stage: 'Crecimiento Temprano',
    industry: 'Salud Digital',
    ownerId: 'user_emprendedor_2',
    documents: [
      {
        id: 'doc_3',
        name: 'Flujo de Caja Proyectado',
        type: 'Flujo de Caja',
        url: '/documents/healthconnect-cashflow.xlsx',
        uploadedAt: '2024-03-01T10:00:00Z'
      }
    ],
    milestones: [
      {
        id: 'milestone_4',
        title: 'Lanzar MVP',
        description: 'Lanzar versión beta de la aplicación',
        completed: true
      },
      {
        id: 'milestone_5',
        title: 'Alcanzar 1000 usuarios',
        description: 'Conseguir 1000 usuarios activos',
        completed: true
      },
      {
        id: 'milestone_6',
        title: 'Alianza con hospitales',
        description: 'Establecer alianzas con 5 hospitales regionales',
        completed: false,
        dueDate: '2024-08-31'
      }
    ],
    createdAt: '2024-02-01T10:00:00Z',
    updatedAt: '2024-04-15T10:00:00Z'
  },
  {
    id: 'p3',
    name: 'EduPlay',
    description: 'Plataforma educativa gamificada para niños',
    elevatorPitch: 'Transformamos el aprendizaje en una aventura divertida para niños de 6-12 años',
    stage: 'Idea',
    industry: 'EdTech',
    ownerId: 'user_emprendedor_3',
    documents: [],
    milestones: [
      {
        id: 'milestone_7',
        title: 'Definir propuesta de valor',
        description: 'Completar análisis de mercado y definir propuesta',
        completed: true
      },
      {
        id: 'milestone_8',
        title: 'Diseñar prototipo',
        description: 'Crear mockups y prototipos de la plataforma',
        completed: false,
        dueDate: '2024-05-31'
      }
    ],
    createdAt: '2024-03-10T10:00:00Z',
    updatedAt: '2024-03-25T10:00:00Z'
  },
  {
    id: 'p4',
    name: 'AgriSmart',
    description: 'Sistema de agricultura de precisión con IA',
    elevatorPitch: 'Aumentamos la productividad agrícola en un 30% mediante IA y sensores inteligentes',
    stage: 'Validación',
    industry: 'AgTech',
    ownerId: 'user_emprendedor_4',
    documents: [
      {
        id: 'doc_4',
        name: 'Pitch Deck AgriSmart',
        type: 'Pitch Deck',
        url: '/documents/agrismart-pitch.pdf',
        uploadedAt: '2024-02-20T10:00:00Z'
      }
    ],
    milestones: [
      {
        id: 'milestone_9',
        title: 'Prueba piloto con agricultores',
        description: 'Realizar pruebas con 5 agricultores locales',
        completed: true
      },
      {
        id: 'milestone_10',
        title: 'Validar modelo de IA',
        description: 'Alcanzar 85% de precisión en predicciones',
        completed: false,
        dueDate: '2024-06-30'
      }
    ],
    createdAt: '2024-01-20T10:00:00Z',
    updatedAt: '2024-04-10T10:00:00Z'
  }
];
